import format from 'date-fns/format';

export const getDisplayDate = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};
